import React from 'react';
import { UsersIcon, AwardIcon, ShieldIcon, LightbulbIcon, BriefcaseIcon } from 'lucide-react';
const reasons = [{
  title: 'Client-Centric Approach',
  description: 'We provide practical legal solutions tailored to your business strategy.',
  icon: UsersIcon
}, {
  title: 'Experienced Team',
  description: 'We have deep sector-specific experience that ensures comprehensive legal insight.',
  icon: AwardIcon
}, {
  title: 'Integrity & Professionalism',
  description: 'We adhere to the highest ethical and professional standards.',
  icon: ShieldIcon
}, {
  title: 'Innovative & Adaptive',
  description: 'We embrace innovation, legal technology, and a forward-thinking mindset.',
  icon: LightbulbIcon
}, {
  title: 'End-to-End Support',
  description: 'From legal advisory to transactional support and dispute resolution, we provide a seamless experience.',
  icon: BriefcaseIcon
}];
export function WhyChooseUs() {
  return <section id="why-choose-us" className="py-32 lg:py-40 bg-cream-dark relative overflow-hidden" data-id="element-201">
      {/* Decorative gold circle */}
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/3 w-[800px] h-[800px] rounded-full border-[1px] border-[#D4AF37]/20 pointer-events-none" data-id="element-202" />
      <div className="absolute top-1/2 right-0 -translate-y-1/2 translate-x-1/3 w-[600px] h-[600px] rounded-full border-[1px] border-[#D4AF37]/10 pointer-events-none" data-id="element-203" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-204">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center" data-id="element-205">
          <div className="pr-0 lg:pr-12 order-2 lg:order-1" data-id="element-206">
            <div className="flex items-center space-x-4 mb-6" data-id="element-207">
              <div className="h-px w-8 bg-[#D4AF37]" data-id="element-208"></div>
              <h2 className="text-xs font-cormorant font-bold tracking-[0.3em] text-[#D4AF37] uppercase" data-id="element-209">
                The Wanja Konji Difference
              </h2>
            </div>

            <h3 className="font-playfair text-5xl md:text-6xl font-bold text-navy tracking-tight mb-10 leading-tight" data-id="element-210">
              Why Choose{' '}
              <span className="italic font-light text-[#2567A4]" data-id="element-211">Us</span>
            </h3>

            <p className="font-cormorant text-2xl text-gray-700 leading-relaxed mb-12 italic" data-id="element-212">
              We go beyond traditional legal services. We partner with you to
              sustainably grow and strengthen your business, ensuring that our
              legal solutions are perfectly aligned with your long-term
              strategic goals.
            </p>

            <div className="w-24 h-0.5 gold-gradient-bg mb-12" data-id="element-213"></div>

            {/* Professional Image */}
            <div className="relative h-[350px] overflow-hidden border border-[#D4AF37]/20 shadow-[0_20px_50px_rgba(0,0,0,0.08)] group" data-id="element-214">
              <img src="https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&q=80&w=2069" alt="Professional business handshake" className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-1000 transform group-hover:scale-105" data-id="element-215" />
              <div className="absolute inset-0 bg-navy/20 mix-blend-multiply" data-id="element-216" />
              <div className="absolute inset-0 border-2 border-[#D4AF37] opacity-0 group-hover:opacity-100 scale-95 group-hover:scale-100 transition-all duration-700 m-4" data-id="element-217" />
            </div>
          </div>

          <div className="space-y-10 order-1 lg:order-2" data-id="element-218">
            {reasons.map((reason, index) => {
            const Icon = reason.icon;
            return <div key={index} className="flex items-start group p-6 -m-6 rounded-lg hover:bg-cream transition-colors duration-500 border border-transparent hover:border-[#D4AF37]/10" data-id="element-219">
                  <div className="flex-shrink-0 mt-1" data-id="element-220">
                    <div className="w-14 h-14 rounded-full border border-[#D4AF37]/30 bg-cream flex items-center justify-center group-hover:bg-[#D4AF37] group-hover:border-[#D4AF37] transition-all duration-500 shadow-sm" data-id="element-221">
                      <Icon className="h-6 w-6 text-[#D4AF37] group-hover:text-white transition-colors duration-500" strokeWidth={1.5} data-id="element-222" />
                    </div>
                  </div>
                  <div className="ml-8" data-id="element-223">
                    <h4 className="font-playfair text-2xl font-bold text-navy mb-3 tracking-tight group-hover:text-[#D4AF37] transition-colors duration-300" data-id="element-224">
                      {reason.title}
                    </h4>
                    <p className="text-gray-600 font-light leading-relaxed" data-id="element-225">
                      {reason.description}
                    </p>
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}